import { size } from '@styles/theme'
import styled from '@emotion/styled'


const ReplyLineDiv = styled.div`
  height: 100%;
  width: 4px;
  // width: 2px;
  // background-color: #141414;
  // background-color: #333333;
  background-color: rgba(150,150,150,0.2);
  position: absolute;
  left: ${size(2.75)};
  // left: ${size(3.9)};
  top: ${size(5)};
  border-radius: 100px;
`

const ReplyLine = ({ isVisible, displayAbove=false }) => {
  
  const renderAboveOrBelow = () => {
    if (displayAbove) {
      return {
        top: size(-1),
        height: size(5),
      }
    }
  }

  if (isVisible) return (
    <ReplyLineDiv className='reply-line' style={renderAboveOrBelow()} />
  )
}

export { ReplyLine }
